import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { createEvent, updateEvent } from "../redux/actions/eventaction";


function EventForm({ currentId, setCurrentId }) {
    const post = useSelector((state) => currentId ? state.eventReducer.find((p) => p._id === currentId) : null);

    const [values, setValues] = useState({
        title: "",
        eventurl: "",
        startdate: "",
        location: "",
    })

    useEffect(() => {
        if (post) setValues(post)
    }, [post])


    const dispatch = useDispatch();
    const handleChange = (ev) => {
        setValues({
            ...values,
            [ev.target.name]: ev.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (currentId) {
            dispatch(updateEvent(currentId, values));
            alert("Event updated successfully. Refresh your browser to view event")
            clearEvent()
        } else {
            dispatch(createEvent(values));
            console.log("here is it", values)
            alert("Event created successfully. Refresh your browser to view event")
            clearEvent()
        }

    }

    const clearEvent = () => {
        setCurrentId(null);
        setValues({
            title: "",
            eventurl: "",
            startdate: "",
            location: "",
        })
    }
    return (
        <div>
            <div className='container'>
                <div className='content-container'>
                    <div className='content-display'>
                        <h2>{currentId ? "Editing Event " : "Add New Event "}</h2>

                        <div className='form-input'>
                            <div className='row'>
                                <div className='col-lg-1 col-md-1 col-sm-12'></div>
                                <div className='col-lg-10 col-md-10 col-sm-12'>
                                    <form onSubmit={handleSubmit} >

                                        <div className='input-div'>
                                            <label > Event title</label>
                                            <input type="text" placeholder="Event title" name="title" value={values.title} required className='inputfield' onChange={handleChange} />
                                        </div>

                                        <div className='input-div'>
                                            <label>Event url</label>
                                            <input type="url" placeholder="Event url (if any)" name="eventurl" className='inputfield' value={values.eventurl} onChange={handleChange} />
                                        </div>
                                        <div className='input-div'>
                                            <label>Event Start date</label>
                                            <input type="date" placeholder="start date" name="startdate" className='inputfield' value={values.startdate} required onChange={handleChange} />
                                        </div>
                                        <div className='input-div'>
                                            <label>Event Location</label>
                                            <input type="text" placeholder="Event location" name="location" className='inputfield' value={values.location} required onChange={handleChange} />
                                        </div>

                                        <div className='button-div'>
                                            <button onClick={clearEvent} className="submitButton clear">Clear</button>
                                            <button type="submit" className='submitButton'>Submit</button>

                                        </div>

                                    </form>
                                </div>
                                <div className='col-lg-1 col-md-1 col-sm-12'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventForm